import { render, staticRenderFns } from "./btn-tertiary2.vue?vue&type=template&id=497e16b2&scoped=true&"
import script from "./btn-tertiary2.vue?vue&type=script&lang=js&"
export * from "./btn-tertiary2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e16b2",
  null
  
)

export default component.exports